import { Component, OnInit,Input } from '@angular/core';
import { bookCategories, bookCategoeyEnums } from '../../../shared/models/shelfEnums';
@Component({
  selector: 'app-bookInfo',
  templateUrl: './bookInfo.component.html',
  styleUrls: ['./bookInfo.component.css']
})
export class BookInfoComponent implements OnInit {
  @Input() data: any;
  constructor() { }
  bookDetails;
  bookCategoeyEnums;
  bookCategoryTypes

  ngOnInit() {
    this.bookDetails = this.data.popupProps.curComp.bookObj;
    this.bookCategoeyEnums = bookCategoeyEnums;
    this.bookCategoryTypes = bookCategories;
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/bookInfo/bookInfo.component.ts